import * as yup from 'yup';

export const CreateStudentDebtFormValidation = yup.object().shape({
  idStudent: yup.string().required('Estudante é obrigatório'),
  idPaymentType: yup.string().required('Tipo de pagamento é obrigatório'),
  originalAmount: yup.number().typeError("deve ser valor").required('Valor é obrigatória'),
  currentAmount: yup.number().typeError("deve ser valor").required('Valor é obrigatória'),
  dueDate: yup.string().required('Data é obrigatória')
    .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
  // .test('is-past', 'Data de nascimento não pode ser no futuro',
  //   (value) => !value || new Date(value) <= new Date())
  ,
  bankEntity: yup.string()
    .when('generateRef', {
      is: 'true',
      then: schema => schema.required("Campo obrigatório"),
      otherwise: schema => schema.optional()
    })
  ,
});